module.exports = __webpack_public_path__ + "static/media/Josh.a183c6ee.webp";